import { useEffect } from 'react';
import { useTranscricao } from '../../context/TranscricaoContext';
import useWSMessageSender from '../../hooks/useWSMessageSender';

export default function TranscricaoWSSender() {
  const { transcriptions } = useTranscricao();
  const { sendTranscription } = useWSMessageSender();

  // Envia a última transcrição para o WebSocket quando há mudanças
  useEffect(() => {
    if (transcriptions.length > 0) {
      const latestTranscription = transcriptions[transcriptions.length - 1];
      sendTranscription(latestTranscription.text);
    }
  }, [transcriptions, sendTranscription]);

  return null; // Componente invisível
}
